import classNames from 'classnames';

import styles from './ChartKeySwatch.module.scss';

export type ChartKeySwatchShape = 'dot' | 'line' | 'dashed' | 'square';

export interface ChartKeySwatchProps {
    shape: ChartKeySwatchShape;
    /** The series colour, as the chart draws it. */
    color: string;
    /** A square's outline, like the bar's own border. */
    outline?: string;
    /** A dot's diameter: `sm` 8px, `md` 10px. */
    size?: 'sm' | 'md';
    className?: string;
}

/** The mark beside a chart key's label: a dot, a line, a dashed line or an outlined square. */
export function ChartKeySwatch(props: ChartKeySwatchProps) {
    const { shape, color, outline, size = 'sm', className } = props;
    const style =
        shape === 'dashed'
            ? { borderTopColor: color }
            : shape === 'square'
              ? { backgroundColor: color, borderColor: outline }
              : { backgroundColor: color };
    return (
        <span
            className={classNames(
                styles.swatch,
                styles[shape],
                shape === 'dot' && (size === 'md' ? styles.dotMd : styles.dotSm),
                className
            )}
            style={style}
            data-shape={shape}
            aria-hidden="true"
        />
    );
}
